export default __webpack_public_path__ + "static/media/FRASES_14.34a23acf.png";